import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import successImg from '../image/dui_img.png';
import warningImg from '../image/tan_img.png';

class ModalToast extends React.PureComponent {
    state = {
        isOpen: this.props.isOpen || false,
        imgSrc: '',
        element: null,
    };

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        className: PropTypes.string,
        maskClosable: PropTypes.bool,
        type: PropTypes.string,
        onClose: PropTypes.func,
        delay: PropTypes.number,
    };

    static defaultProps = {
        className: '',
        maskClosable: true,
        modalWith: 400,
        type: 'success',
        onClose: () => {},
        delay: 2000,
    };

    static getDerivedStateFromProps = (props, state) => {
        let resOpen = {};

        if (props.isOpen !== state.isOpen) {
            resOpen = { isOpen: props.isOpen };
        }

        return { ...resOpen };
    };

    componentDidMount() {
        this.setImgSrc();
        if (window) {
            this.setState({
                element: window.document.getElementById('modal'),
            });
        }

        setTimeout(() => {
            this.setState(
                {
                    isOpen: false,
                },
                () => {
                    this.props.onClose();
                },
            );
        }, this.props.delay + 500);
    }

    componentWillUnmount() {
        // 组件销毁时清空setState
        this.setState = (state, callback) => {
            return;
        };
    }

    // 关闭弹窗
    close() {
        this.setState({
            isOpen: false,
        });
        this.props.onClose();
    }

    setImgSrc() {
        const { type } = this.props;

        switch (type) {
            case 'success':
                this.setState({
                    imgSrc: 'https://x0.ifengimg.com/ucms/2021_42/0B8C57CAADE2787D21477150D88E41452673E70B_size2_w60_h60.png',
                });
                break;
            case 'warning':
                this.setState({
                    imgSrc: warningImg,
                });
                break;

            default:
                break;
        }
    }

    fadeIn = (element, speed) => {
        this.setState({
            enable: false, // 防止用户连续点击
        });
        if (element.style.opacity !== 1) {
            element.style.display = 'block';
            const _speed = speed || 30;
            let num = 0;
            const st = setInterval(() => {
                num++;
                element.style.opacity = num / 10;
                if (num >= 10) {
                    clearInterval(st);
                    this.setState({
                        enable: true, // 防止用户连续点击
                    });
                }
            }, _speed);
        }
    };

    // 淡出
    fadeOut = (element, speed) => {
        this.setState({
            enable: false,
        });
        if (element.style.opacity !== 0) {
            const _speed = speed || 30;
            let num = 10;
            const st = setInterval(() => {
                num--;
                element.style.opacity = num / 10;
                if (num <= 0) {
                    clearInterval(st);
                    setTimeout(() => {
                        element.style.display = 'none';
                        this.setState({
                            enable: true,
                        });
                    }, 300);
                }
            }, _speed);

            // console.log(st);
        }
    };

    emptyFunc() {}
    // 点击确定触发的事件

    render() {
        const { children, className, maskClosable, type } = this.props;

        const { isOpen, imgSrc } = this.state;

        return (
            <React.Fragment>
                <div className={styles.modalWrap} id="modal" style={{ display: isOpen ? 'block' : 'none' }}>
                    <div className={styles.innerBox}>
                        {imgSrc && <img src={imgSrc} alt="图标类型" />}
                        {children}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default errorBoundary(ModalToast);
